@if (!isPrimitiveList) {
  @for (child of displayObject.children; track child) {
    @if (child.type === DisplayObjectType.GROUP) {
      @defer (on immediate) {
        <vitamui-common-group [displayObject]="child"></vitamui-common-group>
      }
    }
    @if (child.type === DisplayObjectType.LIST) {
      <vitamui-common-list [displayObject]="child"></vitamui-common-list>
    }
    @if (child.type === DisplayObjectType.PRIMITIVE) {
      <vitamui-common-primitive [displayObject]="child"></vitamui-common-primitive>
    }
  }
}

@if (isPrimitiveList) {
  <vitamui-common-data
    [label]="displayObject.displayRule.ui.label | translate"
    [value]="displayObject.value.length === 1 ? displayObject.value[0] : displayObject.value"
  >
  </vitamui-common-data>
}
